import * as React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { CONSOLE_GROUPS, hasAnyGroup } from "../permissions/checkPermissions";

export default function PermissionRedirection() {
    if (hasAnyGroup(CONSOLE_GROUPS)) {
        return <Outlet />;
    } else {
        return <Navigate to="/login" />;
    }
}

/** A console page for some of the console's groups only. Anyone else goes back to the
 *  dashboard rather than onto a page whose data endpoint will refuse them (NEU-1113). */
export function RequireGroups({ groups }) {
    return hasAnyGroup(groups) ? <Outlet /> : <Navigate to="/" replace />;
}
